(() => {
  function init(hero) {
    if (hero.dataset.kfReady) return;
    const root = hero.closest('.shopify-section');
    if (!root) return;
    const labels = JSON.parse(hero.querySelector('[data-kf-labels]').textContent);
    hero.dataset.kfReady = 'true';
    root.classList.add('kf-product');
    let pending = false;
    let defaultApplied = false;
    let offerTouched = false;
    let selection = null;
    const sticky = hero.querySelector('[data-kf-sticky]');
    const stickyButton = sticky?.querySelector('button');
    if (sticky) document.body.append(sticky);
    const mainButton = () => root.querySelector('button[name="add"]');
    function updateSticky() {
      const button = mainButton();
      if (!sticky || !button) return;
      const rect = button.getBoundingClientRect();
      const blocked = button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true';
      stickyButton.disabled = blocked || !selection;
      stickyButton.setAttribute('aria-busy', String(blocked));
      const visible = !!selection && hero.getBoundingClientRect().top < innerHeight && (rect.bottom <= 0 || rect.top >= innerHeight);
      sticky.hidden = !visible;
      document.body.classList.toggle('kf-sticky-visible', visible);
    }
    stickyButton?.addEventListener('click', () => {
      const button = mainButton();
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true') return;
      stickyButton.disabled = true;
      button.click();
      schedule();
    });
    function noteOfferInteraction(event) {
      if (event.isTrusted && event.target.closest('#pumper_bundle_svelte')) offerTouched = true;
    }
    root.addEventListener('pointerdown', noteOfferInteraction, true);
    root.addEventListener('keydown', noteOfferInteraction, true);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    const money = new Intl.NumberFormat(hero.dataset.locale || 'fr', { style: 'currency', currency: hero.dataset.currency || 'EUR' });
    function text(el, value) {
      if (el && el.textContent !== value) el.textContent = value;
    }
    function update() {
      pending = false;
      const widget = root.querySelector('#pumper_bundle_svelte');
      if (!widget) return;
      const heading = widget.querySelector('#pumper__block_title');
      text(heading, labels.heading);
      heading?.style.setProperty('color', '#263b35', 'important');
      heading?.style.setProperty('font-size', '16px', 'important');
      const tiers = [...widget.querySelectorAll('.pumper_block__cb')];
      if (!defaultApplied && tiers.length === 3 && tiers[1].querySelectorAll('.pumper_variant_row').length === 3) {
        const preferred = tiers[1].querySelector('input[type="radio"]');
        if (preferred && !preferred.disabled) {
          defaultApplied = true;
          if (!offerTouched && !preferred.checked) preferred.click();
        }
      }
      let chosen;
      for (let i = 0; i < tiers.length; i += 1) {
        const tier = tiers[i];
        const rows = [...tier.querySelectorAll('.pumper_variant_row')];
        const count = rows.length;
        if (![1, 3, 5].includes(count)) continue;
        const title = tier.querySelector('[data-tier-title]');
        const titleValue = count === 1 ? labels.solo : count === 3 ? labels.trio : labels.collection;
        title?.classList.toggle('kf-gift-title', count > 1);
        if (count === 1) {
          text(title, titleValue);
        } else if (title && (title.textContent !== titleValue || !title.querySelector('.kf-offer-gift'))) {
          const words = titleValue.split(' ');
          const freeText = words.splice(-2).join(' ');
          const badge = document.createElement('strong');
          badge.className = 'kf-offer-gift';
          badge.textContent = freeText;
          title.replaceChildren(document.createTextNode(`${words.join(' ')} `), badge);
        }
        const subtitle = tier.querySelector('[data-tier-offer-subtitle]');
        if (count > 1) text(subtitle, count === 3 ? labels.trio_subtitle : labels.collection_subtitle);
        const paidCount = count === 3 ? 2 : count === 5 ? 3 : 1;
        rows.forEach((row, index) => {
          const isGift = index >= paidCount;
          row.classList.toggle('kf-gift-row', isGift);
          let giftLabel = row.querySelector('.kf-gift-row-label');
          if (isGift) {
            if (!giftLabel) {
              giftLabel = document.createElement('span');
              giftLabel.className = 'kf-gift-row-label';
              const name = document.createElement('span');
              name.className = 'kf-gift-name';
              const badge = document.createElement('strong');
              badge.className = 'kf-gift-badge';
              giftLabel.append(name, badge);
              row.prepend(giftLabel);
            }
            text(giftLabel.querySelector('.kf-gift-name'), labels.gift_label.replace('{number}', index - paidCount + 1));
            text(giftLabel.querySelector('.kf-gift-badge'), labels.gift_badge);
          } else if (giftLabel) {
            giftLabel.remove();
          }
        });
        const info = tier.querySelector('.pumper_block__cbinfo');
        let choiceNote = info?.querySelector('.kf-gift-choice');
        if (count > 1 && info) {
          if (!choiceNote) {
            choiceNote = document.createElement('p');
            choiceNote.className = 'kf-gift-choice';
            info.append(choiceNote);
          }
          text(choiceNote, count === 3 ? labels.gift_choice : labels.gifts_choice);
        } else if (choiceNote) {
          choiceNote.remove();
        }
        if (count === 5) {
          tier.querySelectorAll('.pumper_free-shipping-non-selected-text,.pumper_free-shipping-selected-text').forEach(el => {
            text(el, labels.shipping_band);
            el.style.setProperty('color', '#315e50', 'important');
          });
        }
        const priceEl = tier.querySelector('[id^="pumper_totalAmount_"]');
        const priceText = priceEl?.textContent.trim();
        const normalized = priceText?.replace(/[^\d,.-]/g, '').replace(',', '.');
        const total = Number(normalized);
        if (priceEl && Number.isFinite(total) && total > 0 && hero.dataset.currency === 'EUR') {
          let each = tier.querySelector('.kf-each');
          if (!each) {
            each = document.createElement('p');
            each.className = 'kf-each';
            priceEl.parentElement.append(each);
          }
          text(each, `${money.format(total / count)} ${labels.each}`);
        }
        if (tier.querySelector('input[type="radio"]')?.checked) chosen = { count, priceText };
      }
      if (chosen) {
        selection = chosen;
        let summary = widget.querySelector('.kf-selection-summary');
        if (!summary) {
          summary = document.createElement('p');
          summary.className = 'kf-selection-summary';
          summary.setAttribute('role', 'status');
          summary.setAttribute('aria-live', 'polite');
          widget.append(summary);
        }
        text(summary, `${labels.selected} ${chosen.count} ${chosen.count === 1 ? labels.diffuser : labels.diffusers} · ${chosen.priceText}`);
        const button = root.querySelector('button[name="add"]');
        if (button && !button.disabled && button.getAttribute('aria-busy') !== 'true') {
          const label = chosen.count === 1 ? labels.add_one : labels.add.replace('{count}', chosen.count);
          text(button.querySelector('[data-add-to-cart-text]') || button.querySelector('span'), label);
          const aria = `${label} — ${chosen.priceText}`;
          if (button.getAttribute('aria-label') !== aria) button.setAttribute('aria-label', aria);
        }
        if (sticky) {
          const label = chosen.count === 1 ? labels.add_one : labels.add.replace('{count}', chosen.count);
          text(sticky.querySelector('[data-kf-sticky-count]'), `${chosen.count} ${chosen.count === 1 ? labels.diffuser : labels.diffusers}`);
          text(sticky.querySelector('[data-kf-sticky-price]'), chosen.priceText);
          text(sticky.querySelector('[data-kf-sticky-label]'), label);
          stickyButton.setAttribute('aria-label', `${label} — ${chosen.priceText}`);
        }
      }
      updateSticky();
    }
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy'] });
    root.addEventListener('change', schedule);
    root.addEventListener('click', schedule);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target === root) {
        observer.disconnect();
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        document.body.classList.remove('kf-sticky-visible');
        sticky?.remove();
      }
    });
    update();
  }
  document.querySelectorAll('[data-kf-hero]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kf-hero]').forEach(init));
})();
